export default {
  faculty: {
    id: '',
    code: '',
    nameLocal: '',
    nameEng: '',
  },
  faculties: [],
  processing: false,
  error: null,
  success: null,
}



